(function () {
  var SCROLL_THRESHOLD = 10;
  var ticking = false;

  function update() {
    var header = document.querySelector('.oj-header');
    if (header) header.classList.toggle('oj-header--scrolled', window.scrollY > SCROLL_THRESHOLD);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
